import { EventTeam, HitsterEvent } from '../types';

export interface EventTeamStanding {
  team: EventTeam;
  totalScore: number;
  roundScores: { roundId: string; roundName: string; score: number }[];
  rank: number;
}

export const getEventTeamStandings = (event?: HitsterEvent | null): EventTeamStanding[] => {
  if (!event) {
    return [];
  }

  const teams = event.teams || [];
  const rounds = event.rounds || [];

  const standings = teams.map(team => {
    const roundScores = rounds.map(round => {
      const roundData = team.roundData?.find(data => data.roundId === round.id);

      return {
        roundId: round.id,
        roundName: round.name,
        score: roundData?.totalScore || 0,
      };
    });

    const totalScore = roundScores.reduce((sum, roundScore) => sum + roundScore.score, 0);

    return {
      team,
      totalScore,
      roundScores,
      rank: 0,
    };
  });

  standings.sort((a, b) => b.totalScore - a.totalScore);

  let currentRank = 1;
  standings.forEach((standing, index) => {
    if (index > 0 && standing.totalScore < standings[index - 1].totalScore) {
      currentRank = index + 1;
    }

    standing.rank = currentRank;
  });

  return standings;
};

export const eventHasRoundScores = (event?: HitsterEvent | null): boolean => {
  if (!event) {
    return false;
  }

  return (event.teams || []).some(team => (team.roundData || []).length > 0);
};